// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package20CircleFilled: FC<Package20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-.75-11.563v7.376l-5.5-3.188a1.53 1.53 0 0 1-.552-.542 1.44 1.44 0 0 1-.198-.75v-6.5l6.25 3.604Zm7 4.188-5.5 3.188v-7.375L19 8.832v6.5c0 .278-.066.528-.198.75a1.53 1.53 0 0 1-.552.542Zm.125-9.188-2.458 1.417-6.354-3.666 1.687-.98a1.456 1.456 0 0 1 1.5 0l5.625 3.23ZM14.437 9.73 12 11.125 5.604 7.458l2.438-1.416 6.396 3.687Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Package20CircleFilled;
